import React from 'react';
import { MapIcon, LineChartIcon, LightbulbIcon, BoxIcon } from 'lucide-react';
type Tab = 'COP' | 'inputs' | 'predictions' | 'recommendations';
interface TabNavigationProps {
  activeTab: Tab;
  setActiveTab: (tab: Tab) => void;
}
export const TabNavigation = ({
  activeTab,
  setActiveTab
}: TabNavigationProps) => {
  const tabs = [{
    id: 'COP' as Tab,
    label: 'COP',
    icon: MapIcon
  }, {
    id: 'inputs' as Tab,
    label: 'LogStat & Other Inputs',
    icon: BoxIcon
  }, {
    id: 'predictions' as Tab,
    label: 'Running Estimate Predictions',
    icon: LineChartIcon
  }, {
    id: 'recommendations' as Tab,
    label: 'COA Recommendations',
    icon: LightbulbIcon
  }];
  return <div className="border-b border-gray-200" data-id="element-1407">
      <nav className="flex space-x-8" data-id="element-1408">
        {tabs.map(tab => {
        const Icon = tab.icon;
        return <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${activeTab === tab.id ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1409">
              <Icon className="w-4 h-4 mr-2" data-id="element-1410" />
              {tab.label}
            </button>;
      })}
      </nav>
    </div>;
};